export const TABLEDATA: any = {
  'district-report': [
    {
      district: 'جدة',
      homeTrash: '10',
      commercialTrash: '15',
      agricultralTrash: '58',
      demolitions: '30',
      tires: '48',
      date: '15-01-2020',
      totalWeight: '166'
    },
    {
      district: 'جدة',
      homeTrash: '10',
      commercialTrash: '15',
      agricultralTrash: '58',
      demolitions: '30',
      tires: '48',
      date: '15-01-2020',
      totalWeight: '166'
    },
    {
      district: 'جدة',
      homeTrash: '10',
      commercialTrash: '15',
      agricultralTrash: '58',
      demolitions: '30',
      tires: '48',
      date: '15-01-2020',
      totalWeight: '166'
    },
    {
      district: 'جدة',
      homeTrash: '10',
      commercialTrash: '15',
      agricultralTrash: '58',
      demolitions: '30',
      tires: '48',
      date: '15-01-2020',
      totalWeight: '166'
    }
  ]
};

export const COLUMNS: any = {
  'district-report': [
    {
      field: 'district',
      header: 'البلديات'
    },
    {
      field: 'a0',
      header: 'النفايات المنزلية'
    },
    {
      field: 'a1',
      header: 'النفايات التجارية'
    },
    {
      field: 'a2',
      header: 'النفايات الزراعية'
    },
    {
      field: 'a3',
      header: 'دمارات'
    },
    {
      field: 'a4',
      header: 'إطارات'
    },
    {
      field: 'date',
      header: 'التاريخ'
    },
    {
      field: 'totalWeight',
      header: 'الوزن الكلي بالطن'
    }
  ]
};
